import React from 'react'
import VideoCard from './VideoCard';
import '../styles/Videos.css';


const Videos = ({videos}) => {
    console.log("videoss",videos)
    return (
    <>
      <div className="videos">
        {
          videos.map((item,index)=>{
            return(
            <VideoCard index={index} image={item.image} name={item.name} key={item.image}></VideoCard> 
            )
          })
        }
      </div>      
    </>
    )
}

export default Videos
